const PAYLOAD_ERROR_MESSAGE = "Actual error message";

const hasActualError = (payload) => payload?.message === PAYLOAD_ERROR_MESSAGE;
const normalizeShopId = (value) => String(value ?? "").trim();

const operationBelongsToShop = (operation, currentShopId, operationKnown) => {
  const normalizedCurrentShopId = normalizeShopId(currentShopId);
  if (!normalizedCurrentShopId || !operationKnown) return true;
  return normalizeShopId(operation?.shopId) === normalizedCurrentShopId;
};

export const ORDER_TABS = [
  { id: "all-orders", status: null, label: "All Orders", countKey: "allOrders" },
  { id: "missing-info", status: "MISSING_INFO", label: "Missing Info", countKey: "missingInfo" },
  { id: "processing", status: "PROCESSING", label: "Processing", countKey: "processing" },
  { id: "failed", status: "FAILED", label: "Failed", countKey: "failed" },
  { id: "successful", status: "SUCCESS", label: "Successful", countKey: "successful" },
];

const toBackendDateTime = (value, endOfDay = false) => {
  if (!value) {
    return null;
  }

  if (typeof value === "string" && value.includes(" ")) {
    return value;
  }

  const base = typeof value === "string" ? value.split("T")[0] : value;
  return `${base} ${endOfDay ? "23:59:59" : "00:00:00"}`;
};

export const toOrdersViewModel = (ordersState, currentShopId = null) => {
  const advanceOperationKnown = Object.prototype.hasOwnProperty.call(
    ordersState || {},
    "advanceSearchOperation"
  );
  const advanceBelongsToShop = operationBelongsToShop(
    ordersState?.advanceSearchOperation,
    currentShopId,
    advanceOperationKnown
  );
  const advanceSearch = advanceBelongsToShop
    ? ordersState?.advanceSearch
    : null;
  const scopedCount = (field, operationKey) => {
    const operationKnown = Object.prototype.hasOwnProperty.call(
      ordersState?.countOperations || {},
      operationKey
    );
    return operationBelongsToShop(
      ordersState?.countOperations?.[operationKey],
      currentShopId,
      operationKnown
    )
      ? ordersState?.[field]
      : null;
  };
  const dashboardAll = scopedCount("dashboard_all", "dashboardAll");
  const missing = scopedCount("missing", "missing");
  const pending = scopedCount("pending", "pending");
  const failed = scopedCount("failed", "failed");
  const synced = scopedCount("synced", "synced");

  const rows =
    (Array.isArray(advanceSearch?.shopifyFulfillmentActiveResponses) &&
      advanceSearch.shopifyFulfillmentActiveResponses) ||
    (Array.isArray(advanceSearch?.content) && advanceSearch.content) ||
    (Array.isArray(advanceSearch?.data?.content) && advanceSearch.data.content) ||
    (Array.isArray(advanceSearch?.rows) && advanceSearch.rows) ||
    (Array.isArray(advanceSearch?.items) && advanceSearch.items) ||
    (Array.isArray(advanceSearch?.data) && advanceSearch.data) ||
    (Array.isArray(advanceSearch) && advanceSearch) ||
    [];

  const pageCount =
    Number(
      advanceSearch?.totalPages ??
        advanceSearch?.data?.totalPages ??
        advanceSearch?.page?.totalPages ??
        1
    ) || 1;

  return {
    isLoading:
      !advanceBelongsToShop ||
      Boolean(
        typeof ordersState?.advanceSearchIsRequest === "boolean"
          ? ordersState.advanceSearchIsRequest
          : ordersState?.isRequest
      ),
    error: advanceBelongsToShop
      ? ordersState?.advanceSearchError?.message || null
      : null,
    isAuthenticationError:
      advanceBelongsToShop &&
      (ordersState?.advanceSearchError?.authenticationError === true ||
        hasActualError(ordersState?.advanceSearch)),
    rows,
    pageCount,
    counts: {
      allOrders: Number(dashboardAll?.count || 0),
      missingInfo: Number(missing?.count || 0),
      processing: Number(pending?.count || 0),
      failed: Number(failed?.count || 0),
      successful: Number(synced?.count || 0),
    },
    hasError:
      (advanceBelongsToShop && Boolean(ordersState?.advanceSearchError)) ||
      hasActualError(advanceSearch) ||
      hasActualError(pending) ||
      hasActualError(failed) ||
      hasActualError(synced) ||
      hasActualError(missing),
  };
};

export const toOrdersRequestModel = ({
  page = 0,
  status = null,
  search = "",
  startDate = null,
  endDate = null,
  shopId,
}) => ({
  page,
  ordersStatus: status || null,
  search: search || "",
  startDate: toBackendDateTime(startDate, false),
  endDate: toBackendDateTime(endDate, true),
  shopId,
});
